import { render, staticRenderFns } from "./step03_confirmation.vue?vue&type=template&id=2a601fd4&"
import script from "./step03_confirmation.vue?vue&type=script&lang=js&"
export * from "./step03_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports